// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"styles_imageContainer__1Iym7","image":"styles_image__2wrpL"};